import React, { useEffect, useState } from "react";
import data from "./data";
import { getLaderBoardDataMonthAndWeek } from "../../services/api";

const Monthly = ({ className }) => {
    const [monthData, setMonthData] = useState([]);
    const [weekData, setWeekData] = useState([]);

    const fetchData = async () => {
        try {
            const data = await getLaderBoardDataMonthAndWeek();
            if (data) {
                setMonthData(data?.data?.getDataMonthly);
                setWeekData(data?.data?.getDataWeekLy);
            }
        } catch (error) {
            console.log("%c Line:13 🎂 error", "color:#ea7e5c", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={className}>
            <h4 className="font-extrabold text-[30px] lg:text-[36px] leading-[48px] text-white gap-5">
                Monthly <span className="text-[#FE61BD]">Winners</span>
            </h4>

            <div className="flex items-center justify-between w-full bg-[#1a1a1a] mt-8 h-[62px] py-[20px]">
            <div className="font-medium text-[18px] leading-[30px] text-white w-[15%] text-center">
                    #
                </div>
                <div className="font-medium text-[18px] leading-[30px] text-white w-[20%]"></div>
                <div className="font-medium text-[18px] leading-[30px] text-white w-[40%] text-left">
                    Zealy Username
                </div>
                <div className="font-medium text-[18px] leading-[30px] text-white w-[25%] text-center">
                    XP Points
                </div>
            </div>
            {monthData?.map((obj, i) => {
                return (
                    <div className="flex items-center justify-between w-full bg-transparent h-[62px] py-[20px]">
                    <div className="font-medium text-[18px] leading-[30px] text-[#ababab] w-[15%] text-center">
                                {i + 1}
                            </div>
                        <div className="w-[20%] text-center ">
                            {obj?.img && (
                                <img
                                    src={obj?.img}
                                    alt=""
                                    className="font-medium text-[18px] leading-[30px] text-[#ababab] mx-auto"
                                />
                            )}
                        </div>
                        <div className="font-medium text-[18px] leading-[30px] text-[#ababab] w-[40%] text-left">
                            {obj?._id}
                        </div>
                        <div className="font-medium text-[18px] leading-[30px] text-[#ababab] w-[25%] text-center">
                            {obj?.points}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Monthly;
